import {HttpClient} from "../../service/httpClient/HttpClient";

export class GameTeamMemberService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getaGameTeamMembersList(gameTeamId, page, size, displayName) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-teams/${gameTeamId}/members`,
                {
                    page,
                    size,
                    "display-name": displayName && displayName.length > 0 ? displayName : null
                }
            ).then(resolve).catch(reject)
        })
    }

    updateGamerRole(teamMemberId, role) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `team-members/${teamMemberId}/role`,
                {},
                {
                    role
                }
            ).then(resolve).catch(reject)
        })
    }

    deleteGamer(teamMemberId) {
        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `team-members/${teamMemberId}`,
            ).then(resolve).catch(reject)
        })
    }

    getPlayerList(gameTeamId, page, size, displayName, phoneNumber, nationalCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-teams/${gameTeamId}/suggestions/participant`,
                {
                    page,
                    size,
                    "display-name": displayName && displayName.length > 0 ? displayName : null,
                    "phone-number": phoneNumber && phoneNumber.length > 0 ? phoneNumber : null,
                    "national-code": nationalCode && nationalCode.length > 0 ? nationalCode : null
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewPlayerToTeam(gameTeamId, participantId, role) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `game-teams/${gameTeamId}/members`,
                {
                    "participantId": participantId,
                    "role": role,
                }
            ).then(resolve).catch(reject)
        })
    }

}